import { CommonStatusTag } from 'components/CommonStatusTag';

import { colors } from 'constants/colors';

import { SiteSetupState } from 'data/__generated__';
import { SITE_SETUP_STATES_LABELS } from '../constants/states';

const getColorsFromState = (state: SiteSetupState) => {
    const { green, lightGrey, orange, pureWhite, black } = colors;

    switch (state) {
        case SiteSetupState.Created:
            return { backgroundColor: lightGrey, labelColor: black };
        case SiteSetupState.InProgress:
            return { backgroundColor: orange, labelColor: pureWhite };
        case SiteSetupState.Finished:
            return { backgroundColor: green, labelColor: black };
        case SiteSetupState.Aborted:
            return { backgroundColor: black, labelColor: pureWhite };
    }
};

export const StatusTag = ({ state, showHeading }: { state: SiteSetupState; showHeading?: boolean }) => {
    const { backgroundColor, labelColor } = getColorsFromState(state);
    return (
        <CommonStatusTag
            backgroundColor={backgroundColor}
            labelColor={labelColor}
            label={SITE_SETUP_STATES_LABELS[state]}
            showHeading={showHeading}
        />
    );
};
